<template>
  <div>
    <rabbey-table3
      style="width: 100%"
      ref="ObuyInside"
      :data="items"
      :border="true"
      :fit="true"
      :stripe="true"
      :lazy="true"
      v-loading="loading"
      :columns="columns"
      max-height="600"
    >
    </rabbey-table3>
  </div>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import OrderBuyPro from "../OrderBuyProStatusO.vue";
import statusOrderbuy from "../statusOrderbuy.vue";
export default {
  name: "OrderBuyPInside",
  props: {
    dataApO: {
      type: Object
    }
  },

  data() {
    return {
      CompanyCode: this.$store.state.user.user.CompanySelected,
      loading: false,
      items: [],
      columns: [
        {
          prop: "No",
          label: "N° ",
          width: 150,
          sortable: true
        },
        {
          prop: "BuyName",
          label: "Nombre de Proveedor",
          width: 150,
          sortable: true
        },
        {
          prop: "OStatus",
          label: "Estado Orden",
          width: 150,
          sortable: true,
          formatter: OrderBuyPro
        },
        {
          prop: "BuyNPro",
          label: "N° de compra proveedor",
          width: 150,
          sortable: true
        },
        {
          prop: "LCode",
          label: "Cód.almacén",
          width: 150,
          sortable: true
        },
        {
          prop: "Stat",
          label: "Estado",
          width: 150,
          sortable: true,
          formatter: statusOrderbuy
        },
        {
          prop: "CCode",
          label: "Cód.divisa",
          width: 150,
          sortable: true
        },
        {
          prop: "OrdenD",
          label: "Fecha de Emisión Doc.",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "PDate",
          label: "Fecha de Registro",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "DueD",
          label: "Fecha de vencimiento",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "RequestedRD",
          label: "Fecha de recep.solicitada",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "PDiscountD",
          label: "Fecha Pedido",
          width: 150,
          sortable: true,
          formatter: DatetimeFormatter
        }
      ]
    };
  },
  created() {
    this.getItems();
  },

  methods: {
    getItems() {
      this.loading = true;

      const params = {
        CompanyCode: this.CompanyCode,
        ProviderCode: this.dataApO.ProviderCode
      };
      this.$http
        .get("/api/invoices/GetBuyOrderInsidep", {
          params
        })
        .then(({ data }) => {
          this.items = data;
          // console.log("items dejense ver:", this.items);
        })
        .catch((error) => {
          this.$message.error("Error al consultar de ordenes de compras");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  watch: {
    dataApO: {
      handler: function () {
        this.getItems();
      },
      deep: true
    },

    providerCode() {
      this.getItems();
    }
  }
};
</script>
<style></style>
